import {DateTime} from 'luxon';

export interface LocalizedDate {
  date: string;
  time: string;
}

// Attempts to find local time from exam session's time zone data
// If this fails, we try to match with the browser's local time, but this should very rarely happen
// This fallback should be treated as a last resort error handling, rathern than fully expected behavior
export function getLocalTime(examSession: any, locale: string): LocalizedDate {
  const tryDateTime = (session: any) => {
    if (session.scheduledStartTime == undefined) {
      return undefined
    }

    if (!examSession.scheduledStartTime.timeZone.iana) {
      return undefined
    }

    return DateTime.fromISO(examSession.scheduledStartTime.localTime)
      .setZone(examSession.scheduledStartTime.timeZone.iana)
      .setLocale(locale);
  } 

  let date = tryDateTime(examSession);
  if (date == undefined || !date.isValid) {
    date = DateTime.fromISO(examSession.examTimeUTC)
    .setLocale(locale);
  }

  return {
    date: date.toLocaleString(DateTime.DATE_FULL),
    time: date.toLocaleString({...DateTime.TIME_SIMPLE, timeZoneName: 'longGeneric', hour12: true}),
  }
}
 
export function getLocalization(locale: string){
  if (locale === 'en') return 'en-US';
  if (locale === 'es') return 'es-ES';
  if (locale === 'de') return 'de-DE';
  if (locale === 'fr') return 'fr-FR';
  if (locale === 'ja') return 'ja-JA';
  if (locale === 'ko') return 'ko-KR';
  if (locale === 'zh') return 'zh-CN';
  if (locale === 'zho'){
    return 'zho-CN'
  }else{
    return 'en-US';
  }
}
